import { Box, Button, CloseButton, Dialog, Flex, Icon, Image, Portal } from "@chakra-ui/react";
import { ArrowLeftIcon, ArrowRightIcon } from "@phosphor-icons/react/dist/ssr";
import { useEffect, useState } from "react";

const ModalGallery = ({ data, idx, isOpen, onClose, setIdx }) => {
    const [imageIdx, setImageIdx] = useState(data ? data[idx] : "");
    const handleNext = () => {
        if (idx === data.length - 1) {
            setIdx(0);
        } else {
            setIdx(idx + 1);
        }
    };

    const handlePrev = () => {
        if (idx === 0) {
            setIdx(data.length - 1);
        } else {
            setIdx(idx - 1);
        }
    };

    useEffect(() => {
        if (idx != undefined && idx != null && data) {
            setImageIdx(data[idx]);
        }
    }, [idx, data]);

    return (
        <Dialog.Root
            isOpen={isOpen}
            open={isOpen}
            onOpenChange={() => onClose()}
            size="full"
            placement="center"
        >
            <Portal>
                <Dialog.Backdrop bg="rgba(0, 0, 0, 0.8)" />
                <Dialog.Positioner>
                    <Dialog.Content
                        bg="transparent"
                        boxShadow="none"
                        maxW="80vw"
                        maxH="80vh"
                        margin="auto"
                    >
                        <Dialog.CloseTrigger
                            asChild
                            mt="5%"
                            borderRadius="md"
                            bg="#a0aec0cc"
                            _hover={{ background: "#FFFFFFCC" }}
                        >
                            <CloseButton size="sm" />
                        </Dialog.CloseTrigger>
                        <Dialog.Body
                            p={0}
                            display="flex"
                            alignItems="center"
                            justifyContent="center"
                        >
                            <Flex
                                width="100%"
                                height="100%"
                                alignItems="center"
                                justifyContent="center"
                                position="relative"
                            >
                                <Button
                                    onClick={handlePrev}
                                    position="absolute"
                                    left={{ base: -7, md: -16 }}
                                    h={10}
                                    w={10}
                                    borderRadius="full"
                                    bg="#a0aec0cc"
                                    zIndex={2}
                                    _hover={{ background: "#FFFFFFCC" }}
                                >
                                    <Icon boxSize={{ base: 3, md: 6 }}>
                                        <ArrowLeftIcon />
                                    </Icon>
                                </Button>

                                <Box
                                    width="100%"
                                    height="100%"
                                    display="flex"
                                    alignItems="center"
                                    justifyContent="center"
                                >
                                    <Image
                                        alt="img"
                                        src={
                                            typeof imageIdx === "string" ? imageIdx : imageIdx?.url
                                        }
                                        objectFit="contain"
                                        maxW="100%"
                                        maxH={{ base: "42vh", md: "70vh" }}
                                    />
                                </Box>

                                <Button
                                    onClick={handleNext}
                                    position="absolute"
                                    right={{ base: -7, md: -16 }}
                                    h={10}
                                    w={10}
                                    borderRadius="full"
                                    bg="#a0aec0cc"
                                    zIndex={2}
                                    _hover={{ background: "#FFFFFFCC" }}
                                >
                                    <Icon boxSize={{ base: 3, md: 6 }}>
                                        <ArrowRightIcon />
                                    </Icon>
                                </Button>
                            </Flex>
                        </Dialog.Body>
                    </Dialog.Content>
                </Dialog.Positioner>
            </Portal>
        </Dialog.Root>
    );
};
export default ModalGallery;
